// extracted by mini-css-extract-plugin
export default {"create_button_home":"mainpage_create_button_home__7mzfv","content_wrapper":"mainpage_content_wrapper__jOSCa"};